import { InputHTMLAttributes, JSX, ReactNode } from 'react';
import { AllowedInputTypes } from 'react-otp-input';

import Base from '@/components/@base/@helpers/types';
import BaseProps from '@/components/@base/input/type';
import { SIZE_ENUM } from '@/components/@base/@types';

export enum INPUT_TYPES {
  TEXT = 'text',
  NUMBER = 'number',
  EMAIL = 'email',
  PASSWORD = 'password',
  TEL = 'tel',
}

export enum INPUT_VARIANTS {
  SIMPLE = 'SIMPLE',
}

export default interface Props
  extends BaseProps,
    Base,
    Omit<InputHTMLAttributes<HTMLInputElement>, 'size'> {
  label?: string;
  type?: INPUT_TYPES | AllowedInputTypes;
  variant?: INPUT_VARIANTS;
  size?: SIZE_ENUM;
  errorState?: boolean;
  stickyText?: string;
  Icon?: (params: any) => JSX.Element;
  LeftIcon?: (params: any) => JSX.Element;
  labelClassName?:string;
  LeftIconClass?:string;
  hint?: string;
}
